export default {
  title: {
    id: 'bo_sellers_customer_care_open_tasks_no_request_found_block_title',
    defaultMessage: 'No requests found',
  },
  surtitle: {
    id: 'bo_sellers_customer_care_open_tasks_no_request_found_block_surtitle',
    defaultMessage: 'Nothing to see here.',
  },
}
